/**
 * The EscapeHelper bundles useful static escaping functions.
 */
export default class EscapeHelper {
	/**
	 * Escapes the given string, so it can be used in a regular expression.
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp
	 */
	public static escapeRegex(value: string): string {
		let specialChars: Array<string> = [
			// order matters for these
			"-",
			"[",
			"]",
			// order doesn't matter for any of these
			"/",
			"{",
			"}",
			"(",
			")",
			"*",
			"+",
			"?",
			".",
			"\\",
			"^",
			"$",
			"|"
		];
		let regex: RegExp = new RegExp('[' + specialChars.join('\\') + ']', 'g');

		return value.replace(regex, "\\$&");
	}
}